export default "__VITE_ASSET__B7OK7lt8__"